module.exports = __webpack_public_path__ + "dashboard/img/siren-on_dark.c0e6f2f4046fafb37deeef7bc097d55b.svg";